import { create } from "zustand"

interface AuthState {
  token: string | null
  sessionType: "WAITER" | "ADMIN" | null
  korisnikId: number | null
  ime: string
  prezime: string
  companyId: number | null
  companyName: string
  poslovnaJedinicaId: number | null
  kasaId: number | null
  sessionPrinterId: number | null
  prava: { mozeStorno: boolean; mozeNaplacivati: boolean; mozePopust: boolean }
  setWaiterSession: (data: any) => void
  setAdminSession: (data: any) => void
  setSessionPrinter: (kasaId: number) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  sessionType: null,
  korisnikId: null,
  ime: "",
  prezime: "",
  companyId: null,
  companyName: "",
  poslovnaJedinicaId: null,
  kasaId: null,
  sessionPrinterId: null,
  prava: { mozeStorno: false, mozeNaplacivati: false, mozePopust: false },
  setWaiterSession: (data) => set({
    token: data.token,
    sessionType: "WAITER",
    korisnikId: data.korisnikId,
    ime: data.ime,
    prezime: data.prezime,
    companyId: data.companyId,
    companyName: data.companyName,
    poslovnaJedinicaId: data.poslovnaJedinicaId ?? null,
    kasaId: data.kasaId ?? null,
    sessionPrinterId: data.sessionPrinterId ?? null,
    prava: data.prava
  }),
  setAdminSession: (data) => set({
    token: data.token,
    sessionType: "ADMIN",
    korisnikId: data.korisnikId,
    ime: data.ime,
    prezime: data.prezime
  }),
  setSessionPrinter: (kasaId) => set({ sessionPrinterId: kasaId }),
  clear: () => set({
    token: null, sessionType: null, korisnikId: null, ime: "", prezime: "",
    companyId: null, companyName: "", poslovnaJedinicaId: null, kasaId: null, sessionPrinterId: null,
    prava: { mozeStorno: false, mozeNaplacivati: false, mozePopust: false }
  })
}))
